var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('div',[_c('div',{staticClass:"nedbank-pay-auth-wrapper content-wrapper"},[_c('div',{staticClass:"login-form-wrapper"},[_c('loading',{attrs:{"instruction":"Handling callback from Nedbank Direct..."}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }